import axiosInstance from "./axiosInstance";
import { jwtDecode } from "jwt-decode";
import { mergeUserWithMapping, storeUserSession } from "../utils/userSession";

const unwrapPayload = (payload) => {
    if (Array.isArray(payload)) return payload;
    if (!payload || typeof payload !== "object") return payload;
    if (Array.isArray(payload.content)) return payload.content;
    if (payload.data !== undefined) return unwrapPayload(payload.data);
    return payload;
};

const getEmailFromUser = (user) =>
    String(
        user?.email ??
        user?.user?.email ??
        user?.username ??
        ""
    ).trim().toLowerCase();

const getUserIdFromUser = (user) =>
    user?.id ??
    user?.userId ??
    user?.user_id ??
    user?.user?.id ??
    user?.user?.userId ??
    null;

// LOGIN
export const loginApi = async (data) => {
    const res = await axiosInstance.post("/api/auth/login", data);
    return res.data;
};

// CURRENT USER  ✅ CORRECT ENDPOINT
export const meApi = async () => {
    const res = await axiosInstance.get("/api/auth/me");
    return unwrapPayload(res.data);
};

export const userMappingApi = async (userId) => {
    const res = await axiosInstance.get(`/api/user-mappings/${userId}`);
    return unwrapPayload(res.data);
};

export const userMappingsApi = async () => {
    const res = await axiosInstance.get("/api/user-mappings");
    return unwrapPayload(res.data);
};

const getUserIdFromToken = (token) => {
    if (!token) return null;

    try {
        const decoded = jwtDecode(token);
        return (
            decoded?.userId ??
            decoded?.id ??
            decoded?.uid ??
            decoded?.user_id ??
            decoded?.subId ??
            null
        );
    } catch {
        return null;
    }
};

export const bootstrapUserSession = async (token = localStorage.getItem("token")) => {
    const me = await meApi();
    const userId = getUserIdFromUser(me) ?? getUserIdFromToken(token);
    const meEmail = getEmailFromUser(me);

    let mapping = null;

    if (userId !== null && userId !== undefined) {
        try {
            mapping = await userMappingApi(userId);
        } catch (error) {
            if (error?.response?.status !== 404) {
                throw error;
            }
        }
    }

    if (!mapping && meEmail) {
        try {
            const allMappings = await userMappingsApi();
            const mappingRows = Array.isArray(allMappings) ? allMappings : [];
            mapping = mappingRows.find((row) =>
                getEmailFromUser(row) === meEmail
            ) || null;
        } catch (error) {
            if (!mapping) {
                console.warn("Failed to load fallback user mappings by email");
            }
        }
    }

    const mergedUser = mergeUserWithMapping(me, mapping);
    storeUserSession(mergedUser, mapping);

    return mergedUser;
};
